import type { components } from "../../../api/generated";
import type {
  CrmOrganizationGeoResolvePayload,
  CrmOrganizationListParams,
  CrmOrganizationMutation,
  CrmOrganizationSiteMutation,
} from "../types";

const crmOrganizationCollegeType = "高校";

export type CrmOrganizationItemRaw = components["schemas"]["CrmOrganizationItem"];
export type CrmOrganizationListPageRaw = components["schemas"]["CrmOrganizationListPage"];
export type CrmOrganizationMutationRaw = components["schemas"]["CrmOrganizationMutation"];
export type CrmOrganizationSiteItemRaw = components["schemas"]["CrmOrganizationSiteItem"];
export type CrmOrganizationSiteMutationRaw =
  components["schemas"]["CrmOrganizationSiteMutation"];
export type GeoAreaResolveResultRaw = components["schemas"]["GeoAreaResolveResult"];

/** 映射学校组织列表查询参数。 */
export function mapCrmOrganizationListParams(params: CrmOrganizationListParams) {
  return {
    page: params.page,
    page_size: params.pageSize,
    keyword: normalizeOptionalText(params.keyword),
    org_type: normalizeOptionalText(params.orgType),
    province: normalizeOptionalText(params.province),
    city: normalizeOptionalText(params.city),
    district: normalizeOptionalText(params.district),
    is_disabled: params.isDisabled,
    sort_field: params.sortField,
    sort_direction: params.sortDirection,
  };
}

/** 映射学校组织保存载荷。 */
export function mapCrmOrganizationMutationPayload(
  payload: CrmOrganizationMutation,
): CrmOrganizationMutationRaw {
  const orgType = (payload.orgType.trim() || crmOrganizationCollegeType) as CrmOrganizationMutationRaw["org_type"];
  return {
    org_name: payload.orgName.trim(),
    org_type: orgType,
    org_subtype:
      orgType === crmOrganizationCollegeType
        ? normalizeOptionalText(payload.orgSubtype) as CrmOrganizationMutationRaw["org_subtype"]
        : undefined,
    province: normalizeOptionalText(payload.province),
    city: normalizeOptionalText(payload.city),
    district: normalizeOptionalText(payload.district),
    address: normalizeOptionalText(payload.address),
    is_disabled: payload.isDisabled,
    remark: normalizeOptionalText(payload.remark),
    legacy_id: "",
    org_name_normalized: "",
    spell_code: "",
  };
}

/** 映射学校校区保存载荷。 */
export function mapCrmOrganizationSiteMutationPayload(
  payload: CrmOrganizationSiteMutation,
): CrmOrganizationSiteMutationRaw {
  return {
    site_name: payload.siteName.trim(),
    site_type: normalizeOptionalText(payload.siteType),
    province: normalizeOptionalText(payload.province),
    city: normalizeOptionalText(payload.city),
    district: normalizeOptionalText(payload.district),
    address: payload.address.trim(),
    lng: payload.lng,
    lat: payload.lat,
    geo_status: payload.geoStatus === "confirmed" ? "confirmed" : "unverified",
    is_main_site: payload.isMainSite,
    is_disabled: payload.isDisabled,
    remark: normalizeOptionalText(payload.remark),
    replace_existing_main_site: false,
  };
}

/** 映射 GEO 识别载荷。 */
export function mapCrmOrganizationGeoResolvePayload(payload: CrmOrganizationGeoResolvePayload) {
  return {
    province: payload.province?.trim() ?? "",
    area_name: payload.areaName.trim(),
    scenario: payload.scenario ?? "generic",
    context_name: normalizeOptionalText(payload.contextName),
    organization_site_count: payload.organizationSiteCount,
  };
}

/** 归一化可选文本参数。 */
function normalizeOptionalText(value?: string) {
  const normalized = value?.trim();
  return normalized ? normalized : undefined;
}
